<template>
  <el-card id="sensitiveList" :body-style="{ height: '100%' }" class="h-full">
    <el-row :gutter="10" class="text-14px">
      <el-col :span="24">
        <el-input
          class="w-200px mr-10px"
          v-model="filter.sensitiveWord"
          placeholder="敏感词"
          clearable
        ></el-input>
        <el-button type="primary" size="small" @click="handleSearch()">搜索</el-button>
        <el-button
          @click="handleClick('create')"
          type="primary"
          size="small"
          >新增
        </el-button>
        <el-button
          @click="multipleRemove(selection)"
          type="danger"
          size="small"
          >删除</el-button
        >
        <!-- <el-button size="small" @click="openUploadDialog()"
          >导入
        </el-button> -->
      </el-col>
    </el-row>
    <el-table
      height="calc(100% - 115px)"
      class="mt-20px"
      v-loading="tableLoading"
      :data="sensitiveList"
      @select="selectSingle"
      @select-all="selectAll"
      ref="table"
      border
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column type="index" width="50" label="序号"></el-table-column>
      <el-table-column prop="sensitiveWord" show-overflow-tooltip label="敏感词"></el-table-column>
      <el-table-column prop="replaceWord" show-overflow-tooltip label="替换词"></el-table-column>
      <el-table-column prop="creator" width="150" label="创建人"></el-table-column>
      <el-table-column prop="creationTime" width="250" label="创建时间">
        <template slot-scope="scope">
          <div>{{ dayjs(scope.row.creationTime).format('YYYY-MM-DD HH:mm:ss') }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="270" fixed="right">
        <template slot-scope="scope">
          <el-button
            @click="handleClick('edit', scope.row)"
            size="mini"
            >编辑
          </el-button>
          <el-button @click="singleRemove(scope.row)" size="mini"
            >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="float-right mt-20px"
      background
      @size-change="handleSearch()"
      @current-change="tableCurrentChange"
      :current-page.sync="page.pageNo"
      layout="total, sizes, prev, pager, next, jumper"
      :page-size.sync="page.pageSize"
      :total="page.totalCount"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :pager-count="5"
    ></el-pagination>
    <el-dialog
      :title="title"
      class="mini-dialog"
      :visible.sync="postDialog"
      v-dialogDrag
      :close-on-click-modal="false"
      :before-close="closeDialog"
    >
      <div v-loading="submitLoading">
        <el-form
          label-width="150px"
          :rules="formRules"
          label-position="right"
          :model="form"
          ref="form"
        >
          <el-row>
            <el-col :span="24" :offset="0">
              <el-form-item label="敏感词" prop="sensitiveWord">
                <el-input
                  v-model="form.sensitiveWord"
                  class="w-full"
                  :disabled="mode === 'read'"
                  maxlength="50"
                  type="textarea"
                  placeholder="请输入敏感词"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" :offset="0">
              <el-form-item label="替换词" prop="replaceWord">
                <el-input
                  v-model="form.replaceWord"
                  class="w-full"
                  :disabled="mode === 'read'"
                  placeholder="请输入替换词"
                  maxlength="50"
                  type="textarea"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" v-if="mode !== 'read'" class="flex justify-center items-center">
        <el-button type="primary" :loading="btnLoading" @click="handleSubmit">保存</el-button>
        <el-button @click="closeDialog()">取消</el-button>
      </div>
    </el-dialog>
    <wiz-upload-file
      v-dialogDrag
      @refreshList="handleSearch()"
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
      @exportResults="exportResults"
    ></wiz-upload-file>
  </el-card>
</template>
<script type="text/babel">
import { SensitiveWordsApi } from '@wiz-api/workbench'

const dataApi = new SensitiveWordsApi()

export default {
  name: 'sensitiveList',
  mixins: [],
  data() {
    return {
      mode: 'edit',
      page: {
        totalCount: 0,
        pageSize: 15,
        pageNo: 1,
      },
      submitLoading: false,
      filter: {
        sensitiveWord: '',
      },
      form: {},
      formRules: {
        sensitiveWord: [{ required: true, message: '请输入敏感词', trigger: 'blur' }],
        replaceWord: [{ required: true, message: '请输入替换词', trigger: 'blur' }],
      },
      selection: [],
      title: '',
      sensitiveList: [],
      tableLoading: false,
      btnLoading: false,
      postDialog: false,
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
    }
  },
  computed: {},
  async created() {
    // this.handleSearch()
    this.getSensitiveList()
  },
  methods: {
    async getSensitiveList() {
      this.form.isActive = true
      const [err, res] = await dataApi.page({
        body: {
          pageNo: this.page.pageNo,
          pageSize: this.page.pageSize,
          sensitiveWord: this.filter.sensitiveWord,
        },
      })
      if (!err && res) {
        this.sensitiveList = res.items
        this.page.totalCount = res.totalCount
      }
    },
    closeDialog(done) {
      this.$refs.form.clearValidate()
      if (done) {
        done()
      } else {
        this.postDialog = false
      }
    },
    openUploadDialog() {
      this.uploadFileProps.visible = true
    },
    importTemplate(file) {
      // this.uploadFileProps.btnLoading = true
      // const formData = new FormData()
      // _.forIn({ file }, (value, key) => {
      //   formData.append('fileInput', value)
      // })
      // const [err] = await trendAlarmModelConfigApi.importExcel({
      //   fileInput: formData.get('fileInput'),
      // })
      // this.uploadFileProps.btnLoading = false
      // if (!err) {
      //   this.uploadFileProps.active = 2
      //   this.$message.success(this.$t('导入成功'))
      // }
    },
    // 下载导入结果
    async exportResults() {
      this.$message.warning('下载上传结果')
    },

    // 下载导入模板
    async exportTemplate() {
      // const [err, res] = await trendAlarmModelConfigApi.downloadTemplateFile()
      // // 返回的是文件流
      // if (!err) {
      //   this.downLoadBlob({
      //     name: `${this.$t('趋势劣化预警导入模板')}.xlsx`,
      //     data: res,
      //   })
      // }
    },
    // 列表上下分页
    tableCurrentChange(value) {
      this.page.pageNo = value
      this.getSensitiveList()
    },
    handleSubmit: _.debounce(function async() {
      this.submitLoading = true
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.btnLoading = true
          if (this.mode === 'create') {
            this.addPosition()
            return
          }
          this.editPosition()
        }
      })
      this.submitLoading = false
    }, 500),
    async addPosition() {
      this.form.isActive = true
      const [err, res] = await dataApi.add({ body: this.form })
      if (!err) {
        if (res) {
          this.$message.success('新增敏感词成功')
          this.postDialog = false
          this.handleSearch()
        } else {
          this.$message.warning('该敏感词已存在')
        }
      }
      this.btnLoading = false
    },
    async editPosition() {
      const [err, res] = await dataApi.update({ body: this.form })
      if (!err) {
        if (res) {
          this.$message.success('更新敏感词成功')
          this.postDialog = false
          this.handleSearch()
        } else {
          this.$message.warning('该敏感词已存在')
        }
      }
      this.btnLoading = false
    },
    async handleClick(mode, row) {
      this.mode = mode
      this.form = this.$options.data().form
      if (mode !== 'create') {
        this.form = _.cloneDeep(row)
      }
      this.title = this.modeToTitle(mode)
      this.postDialog = true
    },
    modeToTitle(mode) {
      let title = ''
      switch (mode) {
        case 'edit':
          title = '编辑敏感词'
          break
        case 'create':
          title = '新增敏感词'
          break
        default:
          break
      }
      return title
    },
    async handleSearch() {
      this.page.pageNo = 1
      this.getSensitiveList()
    },
    resetkeyWord() {
      if (this.filter.sensitiveWord !== '') {
        this.filter.sensitiveWord = ''
        this.getSensitiveList()
      }
    },
    // 单条数据删除
    singleRemove(row) {
      this.$confirm('此操作将永久删除该敏感词，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const [err, res] = await dataApi.callDelete({
          id: [row.id],
        })
        if (!err) {
          this.$message.success('删除敏感词成功')
          this.handleSearch()
        }
      })
    },
    // 多条数据删除
    multipleRemove(selection) {
      if (!selection.length) {
        this.$message.warning('请先勾选敏感词再操作！')
        return
      }
      const arrIds = _.map(selection, (i) => {
        return i.id
      })
      this.$confirm('此操作将永久删除敏感词，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        this.selection = []
        const [err, res] = await dataApi.callDelete({ id: arrIds })
        if (!err) {
          this.$message.success('删除敏感词成功')
          this.handleSearch()
        }
      })
    },
    async pageChange(current) {
      this.currentPage = current
      this.handleSearch(this.currentPage)
    },
    sizeChange() {
      this.currentPage = 1
      this.handleSearch(this.currentPage)
    },
    selectSingle(selection) {
      this.selection = selection
    },
    selectAll(selection) {
      this.selection = selection
    },
  },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss" type="text/scss"></style>
